<mat-card>
	<mat-card-header>
		<mat-card-title>
			<button mat-button *ngIf="isLoading" disabled="true">
				<mat-icon>
					<mat-spinner diameter="18"> </mat-spinner>
				</mat-icon>
				Loading
			</button>
			<div class="minus-mat-dialog-title-margin" *ngIf="!isLoading">
				Deleting {{data.SERVICE_NAME}}
			</div>

			<button class="close-button" mat-mini-fab [mat-dialog-close]="false" *ngIf="!isLoading"
				[disabled]="submitting">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-dialog-content *ngIf="!isLoading">
		<app-msg [msg]="confirmMsg"></app-msg>
	</mat-dialog-content>

	<mat-dialog-actions *ngIf="!isLoading && confirmMsg.SUCCESS">
		<div class="row">
			<div class="col-lg-12">
				<button mat-raised-button type="submit" color="warn" (click)="delete()" [disabled]="submitting">
					Delete
					<mat-icon *ngIf="submitting">
						<mat-spinner diameter="18"> </mat-spinner>
					</mat-icon>
				</button>
			</div>
		</div>
	</mat-dialog-actions>
</mat-card>